import { FC, useEffect, useState } from 'react'
import { Props } from '../../../AddExperiencePage'
import { KTSVG } from '../../../../../../_metronic/helpers'
import { ErrorMessage, useFormikContext } from 'formik'
import { EXPERIENCE_STATUS } from '../../../models/ExperienceStatus'
import { validateShowButtonActions } from '../utils'

const renderExtraDetail = (content: string) => {
    if (!content) return null;
    if (content.includes('<') && content.includes('>')) {
        return <div className="tap-add-experience-3-extra-detail my-3 ps-2 pe-4" dangerouslySetInnerHTML={{ __html: content }} />;
    }
    const lines = content.split('\n').map(l => l.trim()).filter(Boolean);
    return (
        <div className="tap-add-experience-3-extra-detail my-3 ps-2 pe-4">
            <ul>
                {lines.map((line, idx) => (
                    <li key={idx}>{line.replace(/^[•\-\*]\s*/, '')}</li>
                ))}
            </ul>
        </div>
    );
};

const Step3:FC<Props> = ({ onBackStep, haveErrors, onLoad, onLoadMessage, onPause, catalogs, onSaveDraft }) => {
    const formik = useFormikContext<any>();
    
    const handleSaveDefinitive = async () => {
        await formik.setFieldValue("status",EXPERIENCE_STATUS.PENDING);
        let haveErrs:boolean = await haveErrors();
        if(!haveErrs){
            await formik.submitForm();
        }
    }

    return (
        <div className="tap-add-experience-3-container">
            {/* HEADER */}
            <div className="tap-add-experience-3-header">
                <div className="tap-add-experience-3-title">
                    { formik?.values?.id > 0 ? 'Edit experience' : 'Your Invitation to Nobilis' }
                </div>
            </div>

            {/* STEP + DIVIDER + CONTENT BLOCK */}
            <div className="tap-add-experience-3-step-block">
                <div className={`tap-add-experience-3-step ${formik?.values?.id > 0 ? 'd-none' : ''}`}>step 3/3</div>
                <div className="tap-add-experience-3-divider" />
                <div className="tap-add-experience-3-section">
                    {/* CONFIDENTIALITY */}
                    <div className="tap-add-experience-3-section-group">
                        <div className="tap-add-experience-3-section-label">
                            Confidentiality & Media Use
                        </div>
                        <div className="tap-add-experience-3-section-description">
                            Discretion is foundational to Nobilis. Each experience must clearly define media use allowance
                        </div>
                    </div>
                    {/* RADIO OPTIONS */}
                    <div className="tap-add-experience-2-radio-row flex-column">
                        {(catalogs?.confidentialities ?? []).map((conf,index)=>{
                            const isSelected = formik.values.confidentiality_type == conf.id;
                            const extraDetail = conf.extraDetail || conf.extra_detail || conf.additionalInfo || conf.additional_info;
                            return (
                                <div key={`radio-confidential-levels-${index}`} className="w-100">
                                    <div className={`tap-add-experience-2-radio-card w-100 ${isSelected ? 'tap-add-experience-2-radio-card--selected' : ''}`}>
                                        <label className="tap-host-option p-6 w-100 flex-row cursor-pointer">
                                            <input
                                                type="radio"
                                                name="confidentiality_type"
                                                value={conf.id}
                                                className="tap-host-radio-input"
                                                checked={isSelected}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            <div className="tap-host-radio">
                                                <div className="tap-host-radio-outer"></div>
                                                <div className="tap-host-radio-inner"></div>
                                            </div>
                                            <div className="tap-add-experience-3-radio-content">
                                                <div className="title">{conf.name}</div>
                                                <div className="subtitle">
                                                    {conf.description}
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                    {extraDetail && renderExtraDetail(extraDetail)}
                                </div>
                            );
                        })}
                        <ErrorMessage name={`confidentiality_type`} component="div" className="tap-add-experience-text text-danger" />
                    </div>
                    {/* CONFIRMATION CHECKBOX */}
                    <label className="tap-add-experience-2-checkbox-row" htmlFor="confidentiality_check">
                        <div className='w-100 d-flex flex-column'>
                            <div className='pf-checkbox mb-2 tap-flex-center'>
                                <input id="confidentiality_check" className="pf-check mt-1" name='confidentiality_check' checked={formik.values.confidentiality_check} onChange={formik.handleChange} onBlur={formik.handleBlur} type="checkbox" />
                                <label htmlFor={`confidentiality_check`} className="tap-add-experience-2-checkbox-text">
                                    I confirm that I have read and understand the Confidentiality and Media use
                                    Policy and acknowledge my responsibilities within the Nobilis Community.
                                </label>
                            </div>
                            <ErrorMessage name={`confidentiality_check`} component="div" className="tap-add-experience-text text-danger" />
                        </div>
                    </label>
                    {/* CANCELLATION SECTION */}
                    <div className="tap-add-experience-3-section-group">
                        <div className="tap-add-experience-3-section-label">
                            Cancellation Policy
                        </div>

                        <div className="tap-add-experience-3-section-description">
                            Cancellation affects attendees and the community trust — please plan carefully.
                        </div>
                    </div>
                    {/* CANCELLATION CHECKBOX */}
                    <label className="tap-add-experience-2-checkbox-row" htmlFor="policy_cancelation_check">
                        <div className='w-100 d-flex flex-column'>
                            <div className='pf-checkbox mb-2'>
                                <input id="policy_cancelation_check" className="pf-check mt-1" name='policy_cancelation_check' checked={formik.values.policy_cancelation_check} onChange={formik.handleChange} onBlur={formik.handleBlur} type="checkbox" />
                                <label htmlFor={`policy_cancelation_check`} className="tap-add-experience-2-checkbox-text">
                                    I confirm that I have read, understand, and agree to comply with
                                    Nobilis’s Host Cancellation Policy, including any financial obligations,
                                    required attendee refunds, and potential impact on my standing within the
                                    community.
                                </label>
                            </div>
                            <ErrorMessage name={`policy_cancelation_check`} component="div" className="tap-add-experience-text text-danger" />
                        </div>
                    </label>
                </div>
            </div>
            {/* FOOTER BUTTONS */}
            <div className="tap-add-experience-2-footer">
                <div role='button' onClick={onBackStep} className="tap-add-experience-2-btn-secondary">
                    back
                </div>
                <div className="tap-add-experience-2-footer-right">
                    {formik?.values?.id > 0 && (<button type="button" className={`tap-add-experience-2-btn-secondary ${validateShowButtonActions('paused',formik)}`} onClick={()=>onPause(true)}>
                        <div>Pause Experience</div>
                    </button>)}
                    <button type="button" className={`tap-add-experience-2-btn-secondary ${validateShowButtonActions('draft',formik)}`} onClick={onSaveDraft}>
                        save for later
                    </button>

                    <button type='button' className="tap-add-experience-2-btn-main tap-flex-center" onClick={handleSaveDefinitive} disabled={formik.isSubmitting || !formik.isValid}>
                        <div className='tap-host-button-text tap-flex-center'>
                            submit
                            &nbsp;<KTSVG path='/media/svg/nobilis/teams_and_partner/waitlist_nb_btn_icon_host_experience_btn.svg' />
                        </div>
                    </button>
                </div>
            </div>
        </div>
    )
}

export { Step3 }